export const NOT_GIVEN_REASONS = [
  "Refused",
  "Nausea",
  "Hospitalised",
  "Social leave",
  "Unavailable dose",
  "Cancelled by client",
  "Absent client",
  "Task already done",
  "Independent intake",
  "Family administered",
  "Optional / Other",
  "Given by partner carer",
  "Please contact carer for info",
];